import React, { useState } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { PaymentService } from "@services";
import ProgressButton from "react-progress-button";
import { SEND_INVOICE_METHODS } from "@constants";
import { Modal } from "../../../../../components";

import "./PaymentConfirmation.scss";

const PaymentConfirmation = ({
	show,
	onCancel,
	onHide,
	invoiceItems,
	router,
	onSendCallback,
	invoiceId,
	method,
}) => {
	const { lang } = global;
	const [buttonState, setButtonState] = useState("");

	const onConfirm = async () => {
		if (invoiceItems.length) {
			setButtonState("loading");
			if (method === SEND_INVOICE_METHODS.GROUP) {
				const bulkSendModel = {
					BillingContactEmail: invoiceItems[0].BillingContactEmail,
					InvoiceIds: invoiceItems.map(elm => elm.NonRKPayInvoiceId || invoiceId),
					SendEmailToMyself: invoiceItems[0].SendEmailToMyself,
					CC: invoiceItems[0].InvoiceCCRecipients,
					BCC: invoiceItems[0].InvoiceBCCRecipients,
				};
				await PaymentService.sendBulkInvoices(bulkSendModel)
					.then(async () => {
						utils.notify({
							type: "success",
							message: lang.t("Invoice(s) sent"),
							timeOut: 2000,
						});
						onHide();

						if (onSendCallback) {
							onSendCallback();
							return;
						}

						router.goBack();
					})
					.catch(({ response: { data } }) => {
						utils.notify({
							type: "error",
							message: data?.Message || lang.t("Error sending invoice(s)"),
							timeOut: 1500,
						});
					})
					.finally(() => {
						setButtonState("");
					});
			} else {
				const sendIndividualModel = invoiceItems.map(elm => ({
					BillingContactEmail: elm.BillingContactEmail,
					InvoiceId: elm.NonRKPayInvoiceId || invoiceId,
					SendEmailToMyself: elm.SendEmailToMyself,
					CC: elm.InvoiceCCRecipients,
					BCC: elm.InvoiceBCCRecipients,
				}));
				await PaymentService.sendV4Invoices(sendIndividualModel)
					.then(async () => {
						utils.notify({
							type: "success",
							message: lang.t("Invoice(s) sent"),
							timeOut: 2000,
						});
						onHide();

						if (onSendCallback) {
							onSendCallback();
							return;
						}

						router.goBack();
					})
					.catch(({ response: { data } }) => {
						utils.notify({
							type: "error",
							message: data?.Message || lang.t("Error sending invoice(s)"),
							timeOut: 1500,
						});
					})
					.finally(() => {
						setButtonState("");
					});
			}
		}
	};

	return (
		<Modal
			show={show}
			onHide={onCancel}
			id="payment-confirmation-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Send Invoice")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="text-center">
					<p>
						{lang.t(
							"Invoices cannot be changed once they are sent to the client, would you like to proceed?",
						)}
					</p>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					onClick={onCancel}
					className="btn btn-link"
				>
					{lang.t("Cancel")}
				</button>
				<ProgressButton
					state={buttonState}
					type="button"
					className="btn btn-primary"
					onClick={onConfirm}
				>
					{lang.t("Send")}
				</ProgressButton>
			</Modal.Footer>
		</Modal>
	);
};

PaymentConfirmation.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	onCancel: PropTypes.func,
	invoiceItems: PropTypes.array,
	router: PropTypes.object,
	onSendCallback: PropTypes.func,
	invoiceId: PropTypes.number,
	method: PropTypes.string,
};

PaymentConfirmation.defaultProps = {
	show: false,
	onCancel: () => {},
	onHide: () => {},
	invoiceItems: [],
	router: {},
	onSendCallback: () => {},
	invoiceId: 0,
	method: "",
};

export default PaymentConfirmation;
